import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import {logEvent} from '@lib/gtm'
import {t} from '@lib/helpers'

import {Form} from './Form'
const FooterWithForm = ({className = ''}) => {
  return (
    <div className={`FooterWithForm ${className}`}>
      <div className='container'>
        <div className='container__info'>
          <div className='address'>
            <Link href='/'>
              <a
                className='Nav__logo-brand'
                title='datawow.co.th'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'Homepage',
                      action: 'Click Homepage',
                    },
                  })
                }}
              >
                <Image
                  src='/images/logo-white.svg'
                  alt='datawow logo'
                  width='296px'
                  height='46px'
                />
              </a>
            </Link>
            <div
              dangerouslySetInnerHTML={{__html: t('layout.Footer.address')}}
            />
            <div className='socials'>
              <a
                className='Footer__links__social'
                href='https://www.facebook.com/datawowai/'
                target='_blank'
                rel='nofollow noopener noreferrer'
              />

              <a
                className='Footer__links__social Footer__links__social--linkedin'
                href='https://www.linkedin.com/company/datawowio/'
                target='_blank'
                rel='nofollow noopener noreferrer'
              />
            </div>
          </div>
          <div className='contact'>
            <a
              href='tel:020245560'
              onClick={() => {
                logEvent({
                  ga: {
                    category: 'Phone',
                    action: 'Click Phone',
                    label: 'Footer',
                  },
                })
              }}
            >
              {t('layout.Footer.tl.tel')}
            </a>

            <a
              href='mailto:sales@datawow.io'
              onClick={() => {
                logEvent({
                  ga: {
                    category: 'Email',
                    action: 'Click Email',
                    label: 'Footer',
                  },
                })
              }}
              style={{fontWeight: 500}}
            >
              {t('layout.Footer.tl.email')}
            </a>

            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.072195349628!2d100.58990201483007!3d13.714077190371894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29feb33e83421%3A0xfe14120eb3d8af4f!2sData%20Wow!5e0!3m2!1sen!2sth!4v1585543617852!5m2!1sen!2sth'
              title='map'
              allowFullScreen
            />
          </div>
        </div>
        <div className='container__form' id='contact'>
          <Form title={t('layout.Footer.form.title')} />
        </div>
      </div>
    </div>
  )
}

export default FooterWithForm
